export default "__VITE_ASSET__7472d8d1__"